<template>
  <v-container
    id="aviso-form"
    fluid
    tag="section"
  >
    <usuario-nao-identificado-form
      v-if="!usuarioIdentificado"
      :titulocard="$t('avisos')"
    />
    <base-material-card
      title="Histórico de Avisos"
      icon="mdi-message"
      color="primary"
      header
      header-classes="text-h5 font-weight-bold white--text"
    >
      <v-card
        v-for="(aviso, index) in avisosPaginados"
        :key="aviso.id"
        outlined
        class="ma-2"
      >
        <v-card-title
          class="d-flex justify-space-between align-center"
          style="cursor: pointer;"
          @click="toggleAviso(index)"
        >
          <!-- <div style="width: 24px; text-align: start;">
            <v-icon
              v-if="aviso.visualizado"
              class="icon-perso"
              color="primary"
            >
              mdi-checkbox-marked-outline
            </v-icon>
          </div> -->
          <span
            style="align-items: start;"
          >
            <v-icon
              v-if="aviso.visualizado"
              class="icon-perso"
              color="primary"
            >
              mdi-checkbox-marked-outline
            </v-icon>
            {{ aviso.titulo }}</span>
          <v-icon class="ml-2">
            {{ avisoExpandidoIndex === index ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </v-card-title>
        <v-expand-transition>
          <v-card-text v-show="avisoExpandidoIndex === index">
            <span v-html="aviso.texto" />
          </v-card-text>
        </v-expand-transition>
      </v-card>
      <v-pagination
        v-model="paginaAtual"
        :length="totalPaginas"
        class="mt-4"
        color="primary"
        circle
        total-visible="5"
      />
    </base-material-card>
  </v-container>
</template>

<script>
  import avisosService from '../../../services/avisosservice'
  export default {
    data () {
      return {
        loading: false,
        usuarioIdentificado: true,
        avisoExpandidoIndex: null,
        avisos: [],
        paginaAtual: 1,
        avisosPorPagina: 10,
      }
    },
    computed: {
      avisosPaginados () {
        const inicio = (this.paginaAtual - 1) * this.avisosPorPagina
        const fim = inicio + this.avisosPorPagina
        return this.avisos.slice(inicio, fim)
      },
      totalPaginas () {
        return Math.ceil(this.avisos.length / this.avisosPorPagina)
      },
    },
    created () {
      this.carregaHistoricoAvisos()
    },
    methods: {
      toggleAviso (index) {
        this.avisoExpandidoIndex = this.avisoExpandidoIndex === index ? null : index

        if (!this.avisosPaginados[index].visualizado) {
          this.setVisualizado(this.avisosPaginados[index])
        }
      },
      async carregaHistoricoAvisos () {
        this.loading = true

        try {
          const resposta = await avisosService.carregaHistoricoAvisos(localStorage.chaveativacao)
          const data = resposta.data.avisos
          // console.log('Avisos recebidos:', JSON.stringify(data))
          if (Array.isArray(data) && data.length > 0) {
            this.avisos = data.map(aviso => ({
              id: aviso.id,
              titulo: aviso.titulo,
              texto: this.convertUrlsToLinks(aviso.texto),
              produtorId: aviso.produtorId,
              visualizado: aviso.visualizado,
            }))
          } else {
            this.avisos = []
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.error('Erro ao buscar avisos:', e)
            this.$router.push('/')
          }
          this.aviso = {}
          this.avisoTexto = ''
        } finally {
          this.loading = false
        }
      },
      convertUrlsToLinks (text) {
        // const urlRegex = /(https?:\/\/[^\s]+)/g
        const urlRegex = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+~#?&//=]*)/g
        return text.replace(urlRegex, function (url) {
          return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
        })
      },
      async setVisualizado (aviso) {
        try {
          const resposta = await avisosService.setVisualizado(localStorage.chaveativacao, aviso.id, aviso.produtorId)

          if (resposta.data.success_request) {
            aviso.visualizado = true
          } else {
            console.error('Erro ao marcar aviso como visualizado:', resposta.data.message)
          }
        } catch (e) {
          console.error('Erro ao buscar avisos:', e)
          this.aviso = {}
          this.avisoTexto = ''
        }
      },
    },

  }
</script>

<style scoped>
.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
.format-text {
  font-size: 12px !important;
}
#btn_confirmar {
  padding-left: 2px;
}
#analise {
  font-weight: bold;
}
.custom-color {
  color: rgb(218, 22, 22);
  text-transform: none;
  height: 5px !important;
  width: 5px !important;
  border-radius: 5px !important;
  margin-top: 13px !important;
  padding: 16px 50px !important;
}
.button-ciencia {
  text-transform: none;
  margin-top: 13px !important;
  height: 5px !important;
  width: 15px !important;
}
.v-sheet .v-toolbar__content .v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab),
.v-sheet .v-toolbar__content .v-btn.v-size--large:not(.v-btn--icon):not(.v-btn--fab) {
  padding: 15px 18px !important;
  border-radius: 10px !important;
}
.custom-button:hover {
  background-color: #d6d1d1 !important;
}
.progress-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}
.icon-perso {
  font-size: 16px !important;
  padding-left: -20px;
  padding-right: 1px;
}
</style>
